import Badge from "@/components/core/badge";
import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket";
import { Button } from "@/components/core/buttons/button";
import { ScrollArea } from "@/components/core/scroller";
import { Searchbar } from "@/components/core/searchbar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/core/tabs";
import Tooltip from "@/components/core/tooltip";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { PdfViewer } from "@/components/pdf-viewer";
import { caseDocumentsQueryOptions } from "@/features/case-document/api/queries/documents-query";
import { useDocumentConfigMutation } from "@/features/dashboard/api/queries/document-config-queries.ts";
import { useAuth } from "@/hooks/use-auth";
import { formatDate } from "@/utils/format-date";
import { DocumentEditor } from "@onlyoffice/document-editor-react";
import { IconDownload, IconFolderExclamation, IconFolderSymlink, IconPrinter } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { z } from "zod";

export const Route = createFileRoute("/_backoffice/serving")({
	validateSearch: z.object({
		status: z.string().optional(),
		type: z.string().optional().nullable(),
		per_page: z.number().optional(),
		page: z.number().nullable().optional(),
	}),
	loaderDeps: ({ search }) => ({
		page: search.page,
		per_page: search.per_page,
		type: search.status,
		search: search.search,
	}),
	// loader: ({ context: { queryClient }, deps }) => {
	// 	return queryClient.ensureQueryData(
	// 		caseDocumentsQueryOptions({
	// 			...deps,
	// 			// type: null,
	// 		}),
	// 	);
	// },
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();
	const [token, setToken] = useState(null);
	const [data, setData] = useState({});
	const [options, setOptions] = useState(null);
	const search = Route.useSearch();
	const [selectedDocument, setSelectedDocument] = useState(null);
	const [activeTab, setActiveTab] = useState("no-data");
	const { user } = useAuth();

	const branchId = user?.branches?.[0]?.assignable?.id;

	const { caseRecordId, ...filteredSearch } = search;
	const caseQuery = useSuspenseQuery(
		caseDocumentsQueryOptions({
			...filteredSearch,
			branch_id: branchId,
		}),
	);
	const documents = caseQuery.data.data;

	const documentTokenMutation = useDocumentConfigMutation();

	useEffect(() => {
		if (selectedDocument?.activity?.media?.length > 0) {
			setActiveTab(selectedDocument.activity.media[0].id);
		} else {
			setActiveTab("no-data");
		}
	}, [selectedDocument]);

	useEffect(() => {
		if (documents.length > 0 && !selectedDocument) {
			setSelectedDocument(documents[0]);
		}
	}, [documents, selectedDocument]);

	// useEffect(() => {
	// 	const fetchToken = async () => {
	// 		if (search.caseRecordId && documents.length > 0) {
	// 			const selectedDocument = documents.find(
	// 				(doc) => doc.case_record_id === search.caseRecordId,
	// 			);
	// 			if (selectedDocument) {
	// 				const fileExtension = selectedDocument?.media.file_name
	// 					.split(".")
	// 					.pop();
	// 				const response = await documentTokenMutation.mutateAsync({
	// 					file_type: fileExtension,
	// 					title: selectedDocument.media.name,
	// 					url: selectedDocument.media.original_url,
	// 					mode: "view",
	// 				});

	// 				setToken(response.token);
	// 				setOptions(response.options);
	// 				setData(selectedDocument);
	// 			}
	// 		}
	// 	};

	// 	fetchToken();
	// }, []);

	// const handleChangeDocument = async (data) => {
	// 	await navigate({
	// 		to: "/serving",
	// 		search: (old) => ({
	// 			...old,
	// 			caseRecordId: data.case_record_id,
	// 		}),
	// 	});
	// 	const fileExtension = data?.media?.file_name.split(".").pop();

	// 	const response = await documentTokenMutation.mutateAsync({
	// 		file_type: fileExtension,
	// 		title: data.media?.name,
	// 		url: data.media?.original_url,
	// 		mode: "view",
	// 	});

	// 	setToken(response.token);
	// 	setOptions(response.options);

	// 	setData(data);
	// };

	return (
		<Content pageName="Document Service">
			{/*<Header title="Document Service" />*/}
			<PanelGroup className="flex flex-row grow w-full h-full" direction="horizontal">
				<Panel defaultSize={30} minSize={20} className="flex flex-col shrink-0 grow h-full max-w-[420px]">
					<div className="flex flex-col w-full gap-2 py-4 px-6 border-b border-border/50">
						<Searchbar
							className="mb-1"
							value={search.search}
							debounceTimeout={500}
							onChange={async (value) => {
								await navigate({
									to: "/serving",
									search: (old) => ({
										...old,
										search: value,
									}),
								});
							}}
						/>
					</div>
					<div className="flex flex-col w-full h-[calc(100svh-216px)] py-2">
						{documents.length !== 0 ? (
							<ScrollArea>
								{documents
									// .filter((document) => document.media !== null)
									.map((document) => (
										// <button
										// 	key={document.id}
										// 	type="button"
										// 	className="flex flex-col w-full px-6 py-2 rounded-md bg-background hover:bg-slate-50"
										// 	onClick={() => {
										// 		handleChangeDocument(document);
										// 	}}
										// >
										<button
											key={document.id}
											type="button"
											className="flex flex-col w-full px-6 py-2 rounded-md bg-background hover:bg-slate-50"
											onClick={() => {
												setSelectedDocument(document);
											}}
										>
											<span className="text-left text-base font-semibold text-foreground-dark">Case No. {document.title}</span>
											<span className="text-left text-base text-foreground/70">
												{document?.case_activity_users?.length > 0 ? (
													<div>
														{document.case_activity_users.map((user, index) => (
															<span key={index} className="items-center space-x-2 mr-1">
																<Badge className="uppercase" size="xs" color="green-light">
																	{user.defendant?.user?.full_name || "No Name Available"}
																</Badge>
															</span>
														))}
													</div>
												) : (
													<div>
														<Badge className="uppercase" size="xs" color="green-light">
															Court
														</Badge>
													</div>
												)}
											</span>
											<span className="text-left text-base text-foreground/70">{document.description}</span>
											<span className="text-left text-base text-foreground/40">Posted on {formatDate(document.created_at)}</span>
										</button>
									))}
							</ScrollArea>
						) : (
							<Blanket width="sm">
								<BlanketInfo title="No Data" message="Looks like you are looking for something non-existent. Select Document first." />
							</Blanket>
						)}
					</div>
				</Panel>

				<PanelResizeHandle className="group flex justify-center items-center h-full w-[12px] border-r border-l border-border/50 bg-white">
					<div className="inline-flex w-[4px] h-[40px] rounded-sm bg-foreground/50 group-hover:bg-foreground/90" />
				</PanelResizeHandle>

				{selectedDocument && (
					<Panel defaultSize={70} minSize={10} className="flex flex-col shrink grow w-full h-full">
						<div className="flex flex-col w-full h-[calc(100svh-90px)] bg-slate-50">
							<div className="sticky top-0 flex flex-row justify-between items-center w-full px-6 py-3 bg-background border-b border-border/50">
								<span className="font-semibold text-foreground-dark text-base">Case No. {selectedDocument.title}</span>
							</div>

							<Tabs value={activeTab} onValueChange={setActiveTab} variant="compact" className="mt-1">
								<TabsList>
									{selectedDocument?.activity?.media?.length > 0 ? (
										selectedDocument.activity.media.map((document, index) => (
											<TabsTrigger
												key={document.id}
												value={document.id}
												className={`px-4 py-2 rounded-md ${activeTab === document.id ? "bg-blue-50 text-blue-900" : "bg-gray-100 text-gray-500"}`}
											>
												{document.name}
											</TabsTrigger>
										))
									) : (
										<TabsTrigger value="no-data" disabled>
											No Documents
										</TabsTrigger>
									)}
								</TabsList>

								{selectedDocument?.activity?.media?.length > 0 ? (
									selectedDocument.activity.media.map((document) => (
										<TabsContent key={document.id} value={document.id}>
											<div
												className="flex flex-col w-full p-4 gap-3 border-b last:border-0 border-dashed border-border
															max-h-[950px] overflow-y-auto"
											>
												<PdfViewer documents={document} file={document.original_url} />
											</div>
										</TabsContent>
									))
								) : (
									<TabsContent value="no-data">
										<div className="max-h-[300px] overflow-y-auto flex justify-center items-center">
											<Blanket width="sm">
												<BlanketImage icon={<IconFolderExclamation size={30} stroke={1.5} />} />
												<BlanketInfo title="No data selected" message="Looks like you are looking for something non-existent. Select a document first." />
											</Blanket>
										</div>
									</TabsContent>
								)}
							</Tabs>
						</div>
					</Panel>
				)}

				{/* <Panel
					defaultSize={70}
					minSize={10}
					className="flex flex-col shrink grow w-full h-full"
				>
					<div className="flex flex-col w-full h-[calc(100svh-90px)] bg-slate-50">
						<div className="sticky top-0 flex flex-row justify-between items-center w-full px-6 py-3 bg-background border-b border-border/50">
							<span className="font-semibold text-foreground-dark text-base">
								Case No. {data.title}
							</span>
							<div className="inline-flex flex-row items-center w-auto gap-2">
								<Tooltip content="Go to Case" side="top">
									<Link
										to={`/case-evaluation/${data.case_record_id}`}
										className="text-foreground/50 hover:text-foreground"
									>
										<Button size="icon" variant="ghost">
											<IconFolderSymlink size={18} stroke={2} />
										</Button>
									</Link>
								</Tooltip>
								<Tooltip content="Print" side="top">
									<Button size="icon" variant="ghost">
										<IconPrinter size={18} stroke={2} />
									</Button>
								</Tooltip>
								<Tooltip content="Download" side="top">
									<Button size="icon" variant="ghost">
										<IconDownload size={18} stroke={2} />
									</Button>
								</Tooltip>
							</div>
						</div>
						<ScrollArea>
							{data.media ? (
								<div style={{ height: "calc(100vh - 52px)" }}>
									{[
										"application/pdf",
										"application/msword",
										"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
									].includes(data.media.mime_type) && (
										<DocumentEditor
											id="onlyoffice-editor"
											documentServerUrl={import.meta.env.VITE_DOC_SERVER_URL} // Update with your document server URL
											config={{
												...options,
												token,
											}}
											width="100%"
											height="100%"
										/>
									)}
								</div>
							) : (
								<Blanket width="sm">
									<BlanketImage
										icon={<IconFolderExclamation size={30} stroke={1.5} />}
									/>
									<BlanketInfo
										title="No data selected"
										message="Looks like you are looking for something non-existent. Select Document first."
									/>
								</Blanket>
							)}
						</ScrollArea>
					</div>
				</Panel> */}
			</PanelGroup>
		</Content>
	);
}
